import APIController from '../core-api-controller';

export const fetchUserData = () => {
  const path = `${APIController.endpointApi}/client_user/orders/current`;
  return APIController.getApiCallback(path);
};

export const collectUserWeightApi = ({ data = {} }) => {
  const path = `${APIController.endpointApi}/anthropometry_measurements`;
  return APIController.postCallback(path, data);
};

export const updateUserWeightApi = ({ id = '', data = {} }) => {
  const path = `${APIController.endpointApi}/anthropometry_measurements/${id}`;
  return APIController.putCallback(path, data);
};

export const fetchMeasurementsApi = (id) => {
  const path = `${APIController.endpointApi}/client_user/users/${id}/fetch_patient_measurements`;
  return APIController.getApiCallback(path);
};

export const fetchUserDashboardConfigApi = () => {
  const path = `${APIController.endpointApi}/client_user/configurations`;
  return APIController.getApiCallback(path);
};
